var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"gl-mt-3 gl-text-sm gl-text-subtle",attrs:{"data-testid":"ai-legal-disclaimer"}},[_vm._v("\n  "+_vm._s(_vm.s__(
      'DuoAgentsPlatform|GitLab Duo can autonomously change code. Responses and changes can be inaccurate. Review carefully.',
    ))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }